import { __DEV__ } from '@toolbox/utils';

import type { FetchValuationArgs, FetchValuationResponseSuccess } from './types';

export async function fetchValuation(data: FetchValuationArgs): Promise<null> {
  return null;
}
